export default __webpack_public_path__ + "static/bylinx-screen-5d0022b74c499196dad5e77097d2bfd0.png";